import {
  isOutsideOrg,
  getOutsideOrgMessage,
  isAccountInactive,
  getAccountInactiveMessage,
  isPermissionDenied,
  getPermissionDeniedMessage,
} from '@1823-partners/core';

/**
 * Report a failure from an **ungated** endpoint, without offering to request a
 * role.
 *
 * ``notifyPermissionError`` from core attaches a "Request access" action to every
 * permission denial, which is right for a call the server actually gates. Most
 * calls in this app are not gated: in ``scenario_server`` only ``save_configs``,
 * ``run_scenario`` and ``upload_scenarios`` carry ``@require_permission``, while
 * the scenario, cusip, book, config, run-history and polling reads carry nothing.
 * A ``permission_denied`` from one of those cannot come from authorization — it
 * would mean an auth or proxy fault — so there is no role that would fix it, and
 * offering to request one invites a meaningless request and hides the real cause.
 *
 * Mirrors ``notifyPermissionError`` otherwise, including its return value, so it
 * drops into the same ``if (!notify…) { generic }`` shape: ``true`` when this
 * handled the error, ``false`` when the caller should report it generically.
 * ``outside_org`` and ``inactive`` are still handled, because those can come back
 * from any route and neither ever carried an action anyway.
 *
 * The message variant is deliberate: it inlines the Permissions-app URL, which
 * is the only useful pointer once there is no button.
 */
export const notifyUngatedFailure = (showNotification, error) => {
  if (isOutsideOrg(error)) {
    showNotification(getOutsideOrgMessage(error), 'error');
    return true;
  }
  if (isAccountInactive(error)) {
    showNotification(getAccountInactiveMessage(error), 'error');
    return true;
  }
  if (isPermissionDenied(error)) {
    showNotification(getPermissionDeniedMessage(error), 'warning');
    return true;
  }
  return false;
};

export default notifyUngatedFailure;
